import React from 'react'
import cn from 'classnames'

import css from './Text.pcss'

interface Props {
	size?: 'L' | 'M' | 'S' | 'CAPTION'
	color?: 'secondary' | 'warning' | 'danger' | 'success' | 'link' | 'inherit'
	bold?: boolean
	inline?: boolean
	className?: string
}

const Text: React.FC<Props> = ({
	size = 'M',
	color = 'default',
	bold,
	inline,
	children,
	className,
}) => {
	const Tag = inline ? 'span' : 'p'
	const computedClassName = cn(
		css.text,
		css[size],
		css[color],
		bold && css.bold,
		className
	)

	return <Tag className={computedClassName}>{children}</Tag>
}

export default Text
